/* eslint-disable @typescript-eslint/no-unused-vars */
import noop from 'lodash/noop'
import pick from 'lodash/pick'

import { FormProps } from '~/common/types/form'
import { IgnoreSaveFormKey, STORAGE_KEY } from '~/form/constants'

import { WorkerFormStorage } from '../types'

type InitialValues = Omit<Required<FormProps>, IgnoreSaveFormKey>

const initialValues: InitialValues = {
  reason: '',
  lastName: '',
  firstName: '',
  tel: '',
  mailAddress: '',
  postal: '',
  addressCity: '',
  addressHomeNumber: '',
  addressBuildingName: '',
  selfPr: '',
  resumeUrl: '',
  skillSheetUrl: '',
  portfolioUrl: '',
  availableLanguages: '',
  availableSoftwares: '',
  socialNetworkUrls: '',
  employmentStatus: '',
  requestForRegistration: true,
}

const clean = (initialValues: InitialValues) => {
  const copied: FormProps = { ...initialValues }
  Object.keys(initialValues).forEach((key) => {
    const value = copied[key as keyof FormProps]
    if (typeof value === 'string' && value.length === 0) {
      delete copied[key as keyof FormProps]
    }
  })

  return copied
}

const createInitialValues = (workerFormValues: WorkerFormStorage = {}) => {
  try {
    const jsonStr = localStorage.getItem(STORAGE_KEY)
    if (jsonStr) {
      const localValues = JSON.parse(jsonStr)
      const cleanedValues = pick(localValues, Object.keys(initialValues))

      return clean({ ...initialValues, ...cleanedValues })
    }
  } catch (error) {
    noop()
  }

  return clean({ ...initialValues, ...workerFormValues })
}

export default createInitialValues
